import { Input } from '@/shared/components/ui/Input';

interface DateRangeFilterProps {
  dateFrom?: string;
  dateTo?: string;
  onDateFromChange: (date: string) => void;
  onDateToChange: (date: string) => void;
}

export function DateRangeFilter({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}: DateRangeFilterProps) {
  return (
    <div className="flex gap-4">
      <Input
        type="date"
        label="From Date"
        value={dateFrom || ''}
        onChange={(e) => onDateFromChange(e.target.value)}
      />
      <Input
        type="date"
        label="To Date"
        value={dateTo || ''}
        onChange={(e) => onDateToChange(e.target.value)}
      />
    </div>
  );
}
